export interface Contractor{
  vendorName: string;
  pointOfContact: string;
  msaExpiryDate: string;
  numberOfDaysLeft: number;
}

export const columnDefs = [
  { headerName: 'Vendor', field: 'vendorName' },
  { headerName: 'POC', field: 'pointOfContact' },
  { headerName: 'MSA Expiry', field: 'msaExpiryDate' },
  { headerName: 'Days Left', field: 'numberOfDaysLeft', cellTemplate: 'customDaysLeftColumn' },
  { headerName: 'Action', field: 'action', cellTemplate: 'customActionColumn' }
];